module.exports = __webpack_public_path__ + "static/media/violinplay_lisztcomprehension.681dcce5.wav";